import axios from '@/axios/api.request'

export const year = (params) => axios.request({
    url: '/statis/year',
    data: params,
    method: 'post'
  })
